import { observer } from 'mobx-react-lite';
import { CommandingViewMode } from 'owa-outlook-service-option-store/lib/store/schema/options/CommandingOptions';
import { getIsViewModeSelected } from 'owa-command-ribbon-store';
import * as React from 'react';

import styles from './CommandRibbon.scss';
import classnamesBind from 'classnames/bind';
const classNames = classnamesBind.bind(styles);

export default observer(function CommandRibbonPlaceholder() {
    const heightStyle = getIsViewModeSelected(CommandingViewMode.SingleLineRibbon)
        ? styles.ribbonBarSingleLine
        : getIsViewModeSelected(CommandingViewMode.CommandBar)
        ? styles.ribbonBarCommandBar
        : styles.ribbonBarMultiline;

    return <div className={classNames(styles.ribbon, heightStyle)} />;
});
